import React from 'react';
// import { Document, Page } from 'react-pdf';
import { Document, Page, pdfjs } from "react-pdf";


import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const styles = theme => ({
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    PDFdocument: {
        maxHeight: 500
    },
    button: {
        margin: '15px 15px 15px 0',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    span: {
        minHeight: 60
    },
    spinnerContainer: {
        height: 220,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '600px !important',
        height: '8px !important',
    },
});

class PdfViewer extends React.Component {

    state = {
        numPages: null,
        // pageNumber: 1,
        bytes: null
    };

    onDocumentLoadSuccess = (document) => {
        const { numPages } = document;
        this.setState({
            numPages,
            // pageNumber: 1,
        });
    };

    changePage = offset => this.setState(prevState => ({
        pageNumber: prevState.pageNumber + offset,
    }));

    previousPage = () => this.changePage(-1);

    nextPage = () => this.changePage(1);

    render() {
        const { numPages } = this.state;

        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div>
                    <Document
                        file={this.props.pdfFile}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                    >

                        {/* <Page pageNumber={pageNumber} /> */}

                        {Array.from(
                            new Array(numPages),
                            (el, index) => {
                                return (
                                    <Page
                                        key={`page_${index + 1}`}
                                        pageNumber={index + 1}
                                        width={1100}
                                    />
                                )
                            },
                        )}

                    </Document>
                </div>
                <div>

                    {/* <p>
                        Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
                    </p> */}

                    {/* <Button className={classes.button}
                        variant="contained"
                        disabled={pageNumber <= 1}
                        onClick={this.previousPage}
                    >
                        Previous
                    </Button>
                    <Button
                        className={classes.button}
                        variant="contained"
                        disabled={pageNumber >= numPages}
                        onClick={this.nextPage}
                    >
                        Next
                    </Button> */}

                    <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={() => {
                            const url = window.URL.createObjectURL(new Blob([this.props.pdfFile], {type: "application/pdf"}));
                            const link = document.createElement('a');
                            link.href = url;
                            link.target ='_blank';
                            //link.setAttribute('download', 'report_' + this.props.name + '.pdf');
                            document.body.appendChild(link);
                            link.click();
                        }}
                    >
                        Descargar
                            </Button>
                    <Button variant="contained" color="secondary" className={classes.button} onClick={() => this.props.hideDialog()}>Cerrar</Button>
                </div>
            </div>
        );
    };

};

PdfViewer.propTypes = {
    pdfFile: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(PdfViewer);